import { useState, type FormEvent } from 'react'
import { ArrowRight, Flame, LockKeyhole, Radio } from 'lucide-react'
import { api, APIError } from '../lib/api'
import { useAuth } from '../lib/auth'
import { Button, Field } from '../components/ui'

export function LoginPage() {
  const { refresh } = useAuth()
  const [identifier, setIdentifier] = useState('')
  const [password, setPassword] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState('')
  const submit = async (event: FormEvent) => {
    event.preventDefault()
    setSubmitting(true)
    setError('')
    try {
      await api('/v1/auth/login', { method: 'POST', body: JSON.stringify({ identifier, password }) })
      await refresh()
    } catch (failure) {
      setError(failure instanceof APIError ? failure.message : 'Blaze could not reach the operations server.')
    } finally {
      setSubmitting(false)
    }
  }
  return (
    <main className="login-page">
      <div className="login-atmosphere" aria-hidden="true"><span /><span /><span /></div>
      <section className="login-intro">
        <div className="login-wordmark"><Flame /><span>BLAZE</span></div>
        <p className="eyebrow"><Radio size={13} /> News intelligence / live</p>
        <h1>Know what changed.<br /><em>Before the echo.</em></h1>
        <p className="login-intro__copy">A real-time operations desk for events, facts, source provenance, and indexing velocity.</p>
        <div className="signal-line"><span>MONITOR</span><i /><span>VERIFY</span><i /><span>CONNECT</span></div>
      </section>
      <section className="login-card" aria-labelledby="login-heading">
        <div className="login-card__index">01 / SECURE ACCESS</div>
        <LockKeyhole size={24} strokeWidth={1.5} aria-hidden="true" />
        <h2 id="login-heading">Enter the operations desk</h2>
        <p>Use your Blaze analyst or administrator account.</p>
        <form onSubmit={submit} className="login-form">
          <Field label="Email or username">
            <input autoComplete="username" required value={identifier} onChange={(event) => setIdentifier(event.target.value)} />
          </Field>
          <Field label="Password">
            <input type="password" autoComplete="current-password" required value={password} onChange={(event) => setPassword(event.target.value)} />
          </Field>
          {error ? <div role="alert" className="form-error">{error}</div> : null}
          <Button type="submit" loading={submitting}>Open Blaze <ArrowRight size={16} /></Button>
        </form>
        <small className="login-card__foot">Authorized Entrilex operators only · Session activity is monitored</small>
      </section>
    </main>
  )
}

